var _svg;
import * as React from "react";
var SvgLogo = function SvgLogo() {
  return _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 256 256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.56 13H101.247c-22.143 0-40.66 17.106-42.774 39.514l-6.413 67.981L40 244l56.718-29.869 6.785-63.167h30.538l32.673-55.296h-57.67l1.3-13.78c.727-7.705 7.195-13.592 14.934-13.592h57.609z"
  })));
};
export default SvgLogo;